export enum BpaFeaturePermission {
  viewStatusReport = 'report-business-plan-show-status-report'
}
